import React from 'react';
import '../template-file-css/document-file-template.css';


export const TCC_DischargePlan = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='TCC_DischargePlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>Discharge Summary</h3></center></p>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Client Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Case #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtClientName' name='txtClientName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtCaseNumber' name='txtCaseNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Client DOB:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Program Enrolled:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtClientDob' name='txtClientDob' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtProgramEnrolled' name='txtProgramEnrolled' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Services Provided to client (Skills Training, Counseling, etc):</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtCounseling' name='txtCounseling' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'>Client Insurance ID:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Date of Admission:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Date of Discharge:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtInsuranceId' name='txtInsuranceId' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDateOfAdmission' name='txtDateOfAdmission' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDateOfDischarge' name='txtDateOfDischarge' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Reason for Admission (primary complaint of client):</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><textarea id='txtReasonForAdmission' name='txtReasonForAdmission' className='add-only'></textarea></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTransition' name='cbTransition' className='add-only' value='Transition' /> Planned Discharge/Transition </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbUnplannedDischarge' name='cbUnplannedDischarge' className='add-only' value='Unplanned Discharge' /> Unplanned Discharge </td>
                    </tr>
                </table>

                <p className='w-750'><b>Check the appropriate type of discharge/transition:</b></p>

                <p className='w-750'><span className='eleHeader'>Discharge Reason </span> </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHigherLevelOfCare' name='cbHigherLevelOfCare' className='add-only' value='Requires higher level of care' /> 1-Requires higher level of care </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNoLongerRequires' name='cbNoLongerRequires' className='add-only' value='No longer requires' /> 2-No longer requires services at this level of care </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLostContact' name='cbLostContact' className='add-only' value='Lost Contact' /> 3-Lost Contact </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIncarcerated' name='cbIncarcerated' className='add-only' value='Incarcerated' /> 4-Incarcerated </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMovedAway' name='cbMovedAway' className='add-only' value='Moved Away' /> 5-Moved away from service areas </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChangeInMedical' name='cbChangeInMedical' className='add-only' value='Change in medical' /> 6-Change in medical insurance </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReceivingServices' name='cbReceivingServices' className='add-only' value='Client receiving services' /> 7-Client receiving services/Tx elsewhere </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFamilyDissatisfied' name='cbFamilyDissatisfied' className='add-only' value='Family dissatisfied' /> 8-Client/Family dissatisfied </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicalAdvice' name='cbMedicalAdvice' className='add-only' value='Medical Advice' /> 9-Left against medical advice </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRefusedServices' name='cbRefusedServices' className='add-only' value='Refused services' /> 10-Refused services </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDeathSuicide' name='cbDeathSuicide' className='add-only' value='Death - suicide' /> 11-Death - suicide </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNonSuicide' name='cbNonSuicide' className='add-only' value='non-suicide' /> 12-Death - non-suicide </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIneligibleForServices' name='cbIneligibleForServices' className='add-only' value='Ineligible for services' /> 13-Ineligible for services/does not meet medical necessity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherSpecify' name='cbOtherSpecify' className='add-only' value='Other' /> 14-Other (specify): <br />
                            <input type='text' id='txtOtherSpecify' name='txtOtherSpecify' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>Discharge Destination:</b>Enter a place of discharge by selecting from the Table Below:                </p>

                <p className='w-750'><span className='eleHeader'>Discharge Destination </span> </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTransferredToPrimary' name='cbTransferredToPrimary' className='add-only' value='Transferred to Primary' /> 1-Transferred to Primary Care Physician
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTransferredToEquivalent' name='cbTransferredToEquivalent' className='add-only' value='Transferred to EQUIVALENT' /> 2-Transferred to EQUIVALENT level of care </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTransferredToHigher' name='cbTransferredToHigher' className='add-only' value='Transferred to HIGHER' /> 3-Transferred to HIGHER level of care </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLowerLevel' name='cbLowerLevel' className='add-only' value='LOWER level' /> 4-Transferred to LOWER level of care </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSelfCare' name='cbSelfCare' className='add-only' value='Self-care' /> 5-Self-care/family/general community support </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNonCountyServices' name='cbNonCountyServices' className='add-only' value='non-county services' /> 6-Unknown: Referred to non-county services </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeverReturned' name='cbNeverReturned' className='add-only' value='Never returned' /> 7-Unknown: Never returned </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNotEligible' name='cbNotEligible' className='add-only' value='Not eligible' /> 8-Unknown: Not eligible for services </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbJail' name='cbJail' className='add-only' value='Jail/Prison' /> 9-Jail/Prison </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNotApplicable' name='cbNotApplicable' className='add-only' value='Not applicable' /> 10-Not applicable </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherSpecify_1' name='cbOtherSpecify_1' className='add-only' value='Other' /> 11-Other (specify): <br />
                            <input type='text' id='txtOtherSpecify_1' name='txtOtherSpecify_1' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>Housing/Living Arrangements at discharge:</b>Circle</p>

                <p className='w-750'><span className='eleHeader'>Living Arrangement </span> </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbHouse' name='cbHouse' className='add-only' value='House' /> A-House or Apartment <br />
                    <input type='checkbox' id='cbAptWithSupport' name='cbAptWithSupport' className='add-only' value='Apt with Support' /> B-House or Apt with Support 
                    <br />
                    <input type='checkbox' id='cbDailySupervision' name='cbDailySupervision' className='add-only' value='Daily Supervision' /> C-House or Apt with Daily Supervision Independent Living Facility 
                    <br />
                    <input type='checkbox' id='cbOtherSupported' name='cbOtherSupported' className='add-only' value='Other Supported' /> D-Other Supported Housing Program 
                    <br />
                    <input type='checkbox' id='cbBoard' name='cbBoard' className='add-only' value='Board' /> E-Board & Care - Adult 
                    <br />
                    <input type='checkbox' id='cbResidential' name='cbResidential' className='add-only' value='Residential' /> F-Residential Tx/Crisis Ctr - Adult 
                    <br />
                    <input type='checkbox' id='cbSubstanceAbuse' name='cbSubstanceAbuse' className='add-only' value='Substance Abuse' /> G-Substance Abuse Residential 
                    Rehab Ctr  
                    <br />
                    <input type='checkbox' id='cbHomeless' name='cbHomeless' className='add-only' value='Homeless' /> H-Homeless/In Shelter 
                    <br />
                    <input type='checkbox' id='cbAdultLocked' name='cbAdultLocked' className='add-only' value='Adult Locked' /> I-MH Rehab Ctr (Adult Locked) 
                    <br />
                    <input type='checkbox' id='cbSnf' name='cbSnf' className='add-only' value='SNF' /> J-SNF/ICF/IMD 
                    <br />
                    <input type='checkbox' id='cbInpatient' name='cbInpatient' className='add-only' value='Inpatient' /> K-Inpatient Psych Hospital
                    <br />
                    <input type='checkbox' id='cbStateHospital' name='cbStateHospital' className='add-only' value='State Hospital' /> L-State Hospital 
                    <br />
                    <input type='checkbox' id='cbCorrectional' name='cbCorrectional' className='add-only' value='Correctional' /> M-Correctional Facility 
                    <br />
                    <input type='checkbox' id='cbFoster' name='cbFoster' className='add-only' value='Foster Home-Child' /> R-Foster Home-Child 
                    <br />
                    <input type='checkbox' id='cbGroup' name='cbGroup' className='add-only' value='Group Home-Child' /> S-Group Home-Child (Level 1-12) 
                    <br />
                    <input type='checkbox' id='cbResidentialTx' name='cbResidentialTx' className='add-only' value='Residential Tx' /> T-Residential Tx Ctr-Child (Level 13-14) 
                    <br />
                    <input type='checkbox' id='cbUnknown' name='cbUnknown' className='add-only' value='Unknown' /> U-Unknown 
                    <br />
                    <input type='checkbox' id='cbCommTx' name='cbCommTx' className='add-only' value='Comm Tx' /> V-Comm Tx Facility (Child Locked) 
                    <br />
                    <input type='checkbox' id='cbChildren' name='cbChildren' className='add-only' value='Children' /> W- Children's Shelter 
                    <br />
                    <input type='checkbox' id='cbOtherSpecify_2' name='cbOtherSpecify_2' className='add-only' value='Other' /> O-Other (Specify): <br/>
                    <input type='text' id='txtOtherSpecify_2' name='txtOtherSpecify_2' className='add-only' />
                    <br />
                </p>

                <p className='w-750'><span className='eleHeader'>Initial Diagnosis:</span>
                <input type='text' id='txtInitialDiagnosis' name='txtInitialDiagnosis' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>Discharge Diagnosis:</span>
                <input type='text' id='txtDischargeDiagnosis' name='txtDischargeDiagnosis' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>Summary of reasons for discharge/transition:</span>
                <textarea id='txtReasonsForDischarge' name='txtReasonsForDischarge' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Client's statement regarding satisfaction of treatment rendered:</span>
                <textarea id='txtClientStatement' name='txtClientStatement' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Post-Termination Plan (include referrals, appointments, and client's reaction):</span>
                <textarea id='txtPostTerminationPlan' name='txtPostTerminationPlan' className='add-only'></textarea>
                </p>

                <table>
                <tr>
                        <td className='w-500'> <span className='eleHeader'>Completed by:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date completed:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCompletedBy' name='txtCompletedBy' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateCompleted' name='txtDateCompleted' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Texas Care Staff Signature and Credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Clinical Supervisor Signature and Credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>






            </div>
        </form>

    )
}